import { render, staticRenderFns } from "./producer_submit_confirm_ciders.vue?vue&type=template&id=7b5a5373&scoped=true"
import script from "./producer_submit_confirm_ciders.vue?vue&type=script&lang=js"
export * from "./producer_submit_confirm_ciders.vue?vue&type=script&lang=js"
import style0 from "./producer_submit_confirm_ciders.vue?vue&type=style&index=0&id=7b5a5373&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5a5373",
  null
  
)

export default component.exports